import createLucideIcon from '../createLucideIcon';

const MoveUpRight = createLucideIcon('MoveUpRight', [
  ['path', { d: 'M13 5H19V11', key: '1n1gyv' }],
  ['path', { d: 'M19 5L5 19', key: '72u4yj' }],
]);

export default MoveUpRight;
